document.addEventListener("alpine:init", () => {
  Alpine.data("ProductForm", () => ({
    current_variant: null,
    variant_restock_dates: [],
    product: null,
    final_sale_threshold: null,
    flags: {
      is_preorder: false,
    },
    preorderObserver: null,
    init() {
      this.InitSelf();
      this.InitWatchers();
      this.CheckPreorder();
      this.SyncDisclaimerProperty();
    },
    InitSelf() {
      const root = this.$el.closest("s-product") || document;
      const dataEl = root.querySelector("#ProductJSON");
      if (dataEl) {
        try { this.product = JSON.parse(dataEl.textContent); } catch (e) {}
      }

      let variant_restock_dates = JSON.parse(this.$el.dataset.variant_restock_dates);
      this.variant_restock_dates = variant_restock_dates;

      let current_variant = JSON.parse(this.$el.dataset.current_variant);
      const fullInit = this.GetFullVariantById && this.GetFullVariantById(current_variant.id);
      if (fullInit) current_variant = Object.assign({}, fullInit, current_variant);
      const rdInit = variant_restock_dates.find((item) => item.id == current_variant.id);
      if (rdInit) current_variant.restock_date = rdInit.restock_date;
      this.current_variant = current_variant;
      this.CheckPreorder();
      const urlHasVariantParam = (() => {
        try {
          return new URLSearchParams(window.location.search).has("variant");
        } catch (_) {
          return false;
        }
      })();
      if (urlHasVariantParam) this.SyncVariantMedia(current_variant);
      this.BindMasterSelect();
      this.BindOptionInputs();
    },
    InitWatchers() {
      let am = this;
      const handler = (e) => {
        const detail = e.detail || {};
        let current_variant = detail.variant || detail.selectedVariant || detail.current_variant || detail;
        if (!current_variant || !current_variant.id) return;
        am.UpdateVariantAndUI(current_variant);
      };
      document.addEventListener("variant:change", handler);
      document.addEventListener("variant:changed", handler);
      document.addEventListener("variantChanged", handler);
      this.$el.addEventListener("variant:change", handler);
      const root = this.$el.closest("s-product");
      if (root) root.addEventListener("variant:change", handler);
    },
    UpdateVariantAndUI(variant) {
      let v = variant;
      // Enrich with full variant data so inventory fields are present
      const full = this.GetFullVariantById && this.GetFullVariantById(variant.id);
      if (full) v = Object.assign({}, full, variant);
      const rd = this.variant_restock_dates.find((item) => item.id == v.id);
      if (rd) v.restock_date = rd.restock_date;
      this.current_variant = v;
      this.SyncVariantMedia(v, true);
      setTimeout(this.CheckPreorder.bind(this), 0);
      setTimeout(this.CheckPreorder.bind(this), 150);
      setTimeout(this.SyncDisclaimerProperty.bind(this), 0);
    },
    BindMasterSelect() {
      const root = this.$el.closest("s-product") || document;
      const master = root.querySelector('select[id^="MasterSelect-"]');
      if (!master) return;
      master.addEventListener("change", () => {
        const v = this.GetFullVariantById(master.value);
        if (v) this.UpdateVariantAndUI(v);
      });
    },
    BindOptionInputs() {
      const root = this.$el.closest("s-product") || document;
      const inputs = Array.from(root.querySelectorAll('[js-product-option-selector]'));
      if (!inputs.length) return;
      const onChange = () => {
        const v = this.ResolveVariantFromInputs();
        if (v) this.UpdateVariantAndUI(v);
      };
      inputs.forEach((inp) => inp.addEventListener("change", onChange));
    },
    ResolveVariantFromInputs() {
      if (!this.product || !Array.isArray(this.product.variants)) return null;
      const formEl = this.$el;
      const get = (idx) => formEl.querySelector(`input[data-index="option${idx}"]:checked`);
      const sel = {};
      for (let i = 1; i <= 3; i++) {
        const r = get(i);
        if (r) sel[i] = r.value;
      }
      const handleize = (s) => String(s || "").toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
      return this.product.variants.find((v) => {
        for (let i = 1; i <= 3; i++) {
          if (sel[i] && handleize(v[`option${i}`]) !== sel[i]) return false;
        }
        return true;
      }) || null;
    },
    HasProductTag(tag) {
      const t = String(tag || "").toLowerCase();
      const tags = (this.product && Array.isArray(this.product.tags)) ? this.product.tags : [];
      return tags.map(x => String(x || "").toLowerCase()).includes(t);
    },
    GetDisclaimerValue() {
      if (!this.current_variant) return "";

      if (this.HasProductTag("exchange-only")) {
        return "EXCHANGES ONLY";
      }

      const forceFinalSale = this.HasProductTag("final-sale");
      if (forceFinalSale) return "FINAL SALE";

      const threshold = this.final_sale_threshold;
      if (!Number.isFinite(threshold)) return "";

      const compareAt = Number(this.current_variant.compare_at_price);
      const price = Number(this.current_variant.price);
      if (!Number.isFinite(compareAt) || !Number.isFinite(price) || compareAt <= 0) return "";
      if (compareAt <= price) return "";

      const discountPct = (compareAt - price) / compareAt;
      return discountPct >= threshold ? "FINAL SALE" : "";
    },
    SyncDisclaimerProperty() {
      const input = this.$el.querySelector("#disclaimer-property");
      if (!input) return;

      const value = this.GetDisclaimerValue();
      input.value = value;
      if (value) {
        input.disabled = false;
      } else {
        input.disabled = true;
      }
    },
    CheckPreorder() {
      let am = this;
      const v = am.current_variant || {};
      const isOversell = v.inventory_policy === "continue";
      const qty = Number(v.inventory_quantity);
      const qtyLe0 = !Number.isFinite(qty) || qty <= 0; // treat undefined as 0
      const hasDate = !!v.restock_date;
      am.flags.is_preorder = !!v && ((isOversell && qtyLe0) || (hasDate && v.available && qtyLe0));
      const btn = am.$el.querySelector(".btn[js-add-to-cart]");
      if (!btn) return;
      if (am.flags.is_preorder) {
        am.SetAtcLabel("PREORDER");
        // Keep the label intact even if other scripts overwrite it later
        if (!am.preorderObserver) {
          am.preorderObserver = new MutationObserver(() => {
            if (!am.flags.is_preorder) return;
            if (btn.textContent.trim() !== "PREORDER") {
              am.SetAtcLabel("PREORDER");
            }
          });
          am.preorderObserver.observe(btn, { childList: true, characterData: true, subtree: true });
        }
      } else {
        if (am.preorderObserver) {
          am.preorderObserver.disconnect();
          am.preorderObserver = null;
        }
        // Restore default non-preorder label based on availability
        const fallback = am.current_variant && am.current_variant.available ? "Add To Cart" : "Sold Out";
        am.SetAtcLabel(fallback);
      }
    },
    GetFullVariantById(id) {
      if (!this.product || !Array.isArray(this.product.variants)) return null;
      const vid = String(id);
      return this.product.variants.find(v => String(v.id) === vid) || null;
    },
    SetAtcLabel(label) {
      const btn = this.$el.querySelector(".btn[js-add-to-cart]");
      if (!btn) return;
      const spinner = btn.querySelector("loading-spinner");
      if (spinner) {
        const s = spinner.outerHTML;
        btn.innerHTML = `${s}${label}`;
      } else {
        btn.textContent = label;
      }
    },
    SyncVariantMedia(variant, allowPageScroll) {
      if (!variant) return;
      const root = this.$el.closest("s-product") || document;
      const container = root.querySelector(".product__images [js-carousel]");
      if (!container) return;
      const slides = Array.from(container.querySelectorAll("[js-carousel-slide]"));

      // 1) Try by media id if data-media-id is present
      let targetIndex = -1;
      const mediaId = variant.featured_media && variant.featured_media.id ? String(variant.featured_media.id) : null;
      if (mediaId) {
        targetIndex = slides.findIndex((el) => el.dataset.mediaId === mediaId);
      }

      // 2) Try by image src filename (robust against width params and protocol)
      const getFileKey = (url) => {
        if (!url) return null;
        try {
          const s = String(url).replace(/^https?:/, "");
          const path = s.split("?")[0];
          const parts = path.split("/");
          return parts[parts.length - 1] || null;
        } catch (_) {
          return null;
        }
      };
      if (targetIndex < 0) {
        const targetSrc = (variant.featured_media && (variant.featured_media.preview_image?.src || variant.featured_media.src))
          || (variant.featured_image && variant.featured_image.src)
          || null;
        const targetKey = getFileKey(targetSrc);
        if (targetKey) {
          targetIndex = slides.findIndex((el) => {
            const img = el.querySelector("img");
            if (!img) return false;
            const candidateKey = getFileKey(img.getAttribute("src") || img.currentSrc || "");
            return candidateKey === targetKey;
          });
        }
      }

      // 3) Fallback: match any option token in alt/src
      if (targetIndex < 0 && Array.isArray(variant.options)) {
        const needles = variant.options.map((o) => String(o || "").toLowerCase());
        targetIndex = slides.findIndex((el) => {
          const img = el.querySelector("img");
          if (!img) return false;
          const alt = (img.getAttribute("alt") || "").toLowerCase();
          const src = (img.getAttribute("src") || img.currentSrc || "").toLowerCase();
          return needles.some((n) => n && (alt.includes(n) || src.includes(n)));
        });
      }

      if (targetIndex < 0) return;
      selectProductCarouselSlide(container, targetIndex, { allowPageScroll: !!allowPageScroll });
    },
    GetPreorderText() {
      const date = this.current_variant && this.current_variant.restock_date;
      return date ? `Expected to Ship on ${date}` : '';
    },
  }));
});

function selectProductCarouselSlide(container, targetIndex, options) {
  if (!container) return;
  if (typeof targetIndex !== "number" || targetIndex < 0) return;

  const allowPageScroll = !!(options && options.allowPageScroll);

  const trySelect = (attempt) => {
    const flkty = window.Flickity && window.Flickity.data(container);
    if (flkty && typeof flkty.select === "function") {
      flkty.select(targetIndex, true, true);
      return;
    }

    if (attempt < 20) {
      setTimeout(() => trySelect(attempt + 1), 50);
      return;
    }

    const slides = Array.from(container.querySelectorAll("[js-carousel-slide]"));
    const target = slides[targetIndex];
    if (!target) return;

    try {
      const style = window.getComputedStyle(container);
      const overflowX = style && style.overflowX ? style.overflowX : "";
      const overflowY = style && style.overflowY ? style.overflowY : "";
      const canScrollX = (overflowX === "auto" || overflowX === "scroll") && container.scrollWidth > container.clientWidth;
      const canScrollY = (overflowY === "auto" || overflowY === "scroll") && container.scrollHeight > container.clientHeight;

      if (canScrollX) {
        const left = Math.max(0, (target.offsetLeft || 0) - Math.floor(container.clientWidth / 2));
        container.scrollTo({ left, behavior: "smooth" });
      } else if (canScrollY) {
        const top = Math.max(0, (target.offsetTop || 0) - Math.floor(container.clientHeight / 2));
        container.scrollTo({ top, behavior: "smooth" });
      } else if (allowPageScroll) {
        try {
          target.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch (_) {
          target.scrollIntoView();
        }
      }
    } catch (_) {}
  };

  trySelect(0);
}

function getProductJsonForForm(formEl) {
  try {
    const root = formEl.closest("s-product") || document;
    const dataEl = root.querySelector("#ProductJSON");
    if (!dataEl) return null;
    return JSON.parse(dataEl.textContent);
  } catch (_) {
    return null;
  }
}

function computeDisclaimerValue({ product, variant, threshold }) {
  if (!product || !variant) return "";

  const tags = Array.isArray(product.tags) ? product.tags.map(t => String(t || "").toLowerCase()) : [];
  if (tags.includes("exchange-only")) return "EXCHANGES ONLY";
  if (tags.includes("final-sale")) return "FINAL SALE";

  const t = Number(threshold);
  if (!Number.isFinite(t)) return "";

  const compareAt = Number(variant.compare_at_price);
  const price = Number(variant.price);
  if (!Number.isFinite(compareAt) || !Number.isFinite(price) || compareAt <= 0) return "";
  if (compareAt <= price) return "";

  const discountPct = (compareAt - price) / compareAt;
  return discountPct >= t ? "FINAL SALE" : "";
}

document.addEventListener(
  "submit",
  (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.hasAttribute("js-product-form")) return;

    const input = form.querySelector("#disclaimer-property");
    if (!input) return;

    const product = getProductJsonForForm(form);
    if (!product || !Array.isArray(product.variants)) return;

    const fd = new FormData(form);
    const variantId = String(fd.get("id") || "");
    if (!variantId) return;

    const variant = product.variants.find(v => String(v.id) === variantId) || null;
    if (!variant) return;

    const wrapper = form.closest(".product-atc-form");
    const threshold = wrapper && wrapper.dataset ? wrapper.dataset.final_sale_threshold : null;
    const value = computeDisclaimerValue({ product, variant, threshold });

    input.value = value;
    input.disabled = !value;
  },
  true
);

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('[js-back-to-top]');
  if (!btn) return;

  const SHOW_AFTER_PX = 400;
  const update = () => {
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    if (y > SHOW_AFTER_PX) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  };

  const onClick = (e) => {
    e.preventDefault();
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    } catch (_) {
      window.scrollTo(0, 0);
    }
  };

  btn.addEventListener('click', onClick);
  window.addEventListener('scroll', update, { passive: true });
  update();
});

function removeWishlistFillRule(button) {
  const container = button.parentElement;
  const productData = {
    title: container.dataset.productTitle,
    price: container.dataset.productPrice
      ? container.dataset.productPrice / 100
      : null,
    id: container.dataset.productId,
    currency: container.dataset.productLocalizationisocode,
  };

  const payload = {
    product_title: productData.title,
    product_price: productData.price,
    product_id: productData.id,
    currency: productData.currency,
  };

  const path = button.querySelector("path");
  const computedFillRule = window
    .getComputedStyle(path)
    .getPropertyValue("fill-rule");

  if (computedFillRule === "nonzero") {
    path.style.fillRule = "evenodd";
    document.dispatchEvent(
      new CustomEvent("analytics:custom", {
        detail: {
          event: "Remove from wishlist",
          payload: payload,
        },
      })
    );
  } else {
    document.dispatchEvent(
      new CustomEvent("analytics:custom", {
        detail: {
          event: "Add to wishlist",
          payload: payload,
        },
      })
    );
  }
}

function initWishlistButtons() {
  document
    .querySelectorAll(".swym-add-to-wishlist:not([data-event-initialized])")
    .forEach((button) => {
      button.dataset.eventInitialized = "true";
      button.addEventListener("click", () => {
        removeWishlistFillRule(button);
      });
    });
}
initWishlistButtons();

// Non-Alpine fallback: ensure variant → media sync works even if Alpine isn't running
(function () {
  if (window.__variantMediaSyncBound) return;
  window.__variantMediaSyncBound = true;

  const root = document.querySelector("s-product") || document;
  const formEl = root.querySelector(".product-atc-form");
  if (!formEl) return;

  const parseJSON = (s) => {
    try { return JSON.parse(s); } catch (_) { return null; }
  };
  const productData = (() => {
    const el = root.querySelector("#ProductJSON");
    return el ? parseJSON(el.textContent) : null;
  })();

  const getSlides = () => {
    const container = root.querySelector(".product__images [js-carousel]");
    const slides = container ? Array.from(container.querySelectorAll("[js-carousel-slide]")) : [];
    return { container, slides };
  };

  const getFileKey = (url) => {
    if (!url) return null;
    try {
      const s = String(url).replace(/^https?:/, "");
      const path = s.split("?")[0];
      const parts = path.split("/");
      return parts[parts.length - 1] || null;
    } catch (_) {
      return null;
    }
  };

  const syncToVariant = (variant, allowPageScroll) => {
    if (!variant) return;
    const { container, slides } = getSlides();
    if (!container || !slides.length) return;

    let targetIndex = -1;
    const mediaId = variant.featured_media && variant.featured_media.id ? String(variant.featured_media.id) : null;
    if (mediaId) {
      targetIndex = slides.findIndex((el) => el.dataset.mediaId === mediaId);
    }

    if (targetIndex < 0) {
      const targetSrc = (variant.featured_media && (variant.featured_media.preview_image?.src || variant.featured_media.src))
        || (variant.featured_image && variant.featured_image.src)
        || null;
      const targetKey = getFileKey(targetSrc);
      if (targetKey) {
        targetIndex = slides.findIndex((el) => {
          const img = el.querySelector("img");
          if (!img) return false;
          const candidateKey = getFileKey(img.getAttribute("src") || img.currentSrc || "");
          return candidateKey === targetKey;
        });
      }
    }

    if (targetIndex < 0 && Array.isArray(variant.options)) {
      const needles = variant.options.map((o) => String(o || "").toLowerCase());
      targetIndex = slides.findIndex((el) => {
        const img = el.querySelector("img");
        if (!img) return false;
        const alt = (img.getAttribute("alt") || "").toLowerCase();
        const src = (img.getAttribute("src") || img.currentSrc || "").toLowerCase();
        return needles.some((n) => n && (alt.includes(n) || src.includes(n)));
      });
    }

    if (targetIndex < 0) return;
    selectProductCarouselSlide(container, targetIndex, { allowPageScroll: !!allowPageScroll });
  };

  const findVariantById = (id) => {
    if (!productData || !Array.isArray(productData.variants)) return null;
    return productData.variants.find((v) => String(v.id) === String(id)) || null;
  };

  const resolveFromInputs = () => {
    if (!productData || !Array.isArray(productData.variants)) return null;
    const get = (idx) => formEl.querySelector(`input[data-index="option${idx}"]:checked`);
    const sel = {};
    for (let i = 1; i <= 3; i++) {
      const r = get(i);
      if (r) sel[i] = r.value;
    }
    const handleize = (s) => String(s || "").toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
    return productData.variants.find((v) => {
      for (let i = 1; i <= 3; i++) {
        if (sel[i] && handleize(v[`option${i}`]) !== sel[i]) return false;
      }
      return true;
    }) || null;
  };

  // Bind master select
  const master = root.querySelector('select[id^="MasterSelect-"]');
  if (master) {
    master.addEventListener("change", () => {
      const v = findVariantById(master.value);
      syncToVariant(v, true);
    });
  }

  // Bind swatch inputs
  root.querySelectorAll('[js-product-option-selector]').forEach((inp) => {
    inp.addEventListener("change", () => {
      const v = resolveFromInputs();
      syncToVariant(v, true);
    });
  });

  // Listen to common variant events
  const handler = (e) => {
    const d = e.detail || {};
    const v = d.variant || d.selectedVariant || d.current_variant || null;
    if (v) syncToVariant(v, true);
  };
  document.addEventListener("variant:change", handler);
  document.addEventListener("variant:changed", handler);
  document.addEventListener("variantChanged", handler);

  // Initial sync from embedded data
  const current = parseJSON(formEl.dataset.current_variant || "null");
  const urlHasVariantParam = (() => {
    try {
      return new URLSearchParams(window.location.search).has("variant");
    } catch (_) {
      return false;
    }
  })();
  if (current && urlHasVariantParam) syncToVariant(current, false);
})();
